export default __webpack_public_path__ + "static/icon-17-6-2dad396c8dcb4e7597deb21827ee839b.png";